import React, { useState, useEffect } from 'react'
import Logo from "../Img/logo.png"
import CustomNavLink from "../_Components/CustomNavLink";
import PropTypes from "prop-types";
import API from '../Utils/api';
import { Link } from 'react-router-dom';

async function reload() {
    await window.location.reload()
}

const CambistaTemplate = (props) => {

    const usuario = JSON.parse(localStorage.getItem('user'))

    const removeToggled = (e) => {
        window.localStorage.setItem("rotaAtual", e.target.name);
        //  setTimeout(reload, 100)
    }

    const logout = () => {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem("rotaAtual");
        window.location.href = '/'
    }

    const [expanded, setExpanded] = useState(false);
    const scrollarPage = () => {
        setExpanded(!expanded)
        if (!expanded)
            window.scrollTo(500, 0);
        else {
            window.scrollTo(0, 0);
        }
    }

    const verificarUsuario = async () =>{
        try {
            const response = await API.get("/api/usuarios/verificar/"+JSON.parse(window.localStorage.getItem("user"))._id);
            if(!response.data.status)
                logout();
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        verificarUsuario();
    },[])

    return (
        <div className="wrapper">
            <div className="sidebar">
                <div className="sidebar-wrapper">
                    <div className="logo">
                        <img src={Logo} style={{ width: '10em', height: '4em' }} />
                        <div className="text-center small mt-2">
                            <div style={{ fontWeight: '500' }}>{usuario.nome.toUpperCase()} • {usuario.perfil}</div>
                        </div>
                    </div>
                    <ul className="nav">

                        <CustomNavLink onClick={logout} className="nav-link" >
                            <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                        </CustomNavLink>
                        <CustomNavLink to="/cambista-gerencia-clientes" name="cambista-gerencia-clientes" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-bullet-list-67" />
                            <span>Gerenciar clientes</span>
                        </CustomNavLink>
                        {/*<CustomNavLink to="/cambista-relatorio" className="nav-link">*/}
                        {/*    <i className="nc-icon nc-chart-pie-36"/>*/}
                        {/*    <span>Relatorios</span>*/}
                        {/*</CustomNavLink>*/}
                        <CustomNavLink to="/receber-pedidos" name="receber-pedidos" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-tag-content" />
                            <span>Pedidos</span>
                        </CustomNavLink>
                        <CustomNavLink to="/relatorios-cambista" name="relatorios-cambista" onClick={removeToggled.bind(this)} className="nav-link" >
                            <i class="fas fa-book-open"></i>
                            <span>Relatorios</span>
                        </CustomNavLink>
                        <CustomNavLink to="/loja-cambista" name="loja-cambista" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-istanbul" />
                            <span>Loja cambista</span>
                        </CustomNavLink>
                        <CustomNavLink to="/caixa-cambista" name="caixa-cambista" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-money-coins" />
                            <span>Caixa cambista</span>
                        </CustomNavLink>
                        <CustomNavLink to="/perfil-cambista" name="perfil-cambista" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="nc-icon nc-circle-09" />
                            <span>Perfil</span>
                        </CustomNavLink>
                    </ul>
                </div>
            </div>
            <div className="main-panel">
                <nav className="navbar navbar-expand-lg " color-on-scroll="500">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="#">
                            {props.label}
                        </Link>
                        <button
                            id="sideButton"
                            to="#"
                            className="navbar-toggler navbar-toggler-right"
                            type="button"
                            data-toggle="collapse"
                            aria-controls="navigation-index"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                        </button>
                        <div
                            className="collapse navbar-collapse justify-content-end"
                            id="navigation"
                        >
                            {/* <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <Link className="nav-link"  name="" onClick={removeToggled.bind(this)}>
                                        <span className="no-icon">Sair</span>
                                    </Link>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </nav>
                <div className="content">
                    {props.children}
                </div>
                <footer className="footer">
                    <div className="container-fluid">
                        <nav>
                            <ul className="footer-menu">
                                <li>
                                    <Link to="#">Empresa</Link>
                                </li>
                                <li>
                                    <Link to="#">Regulamento</Link>
                                </li>
                                <li>
                                    <Link to="#">Outros projetos</Link>
                                </li>
                            </ul>
                            <p className="copyright text-center">
                                Proprietário ©
                                <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
        </div>
    )
}

CambistaTemplate.propTypes = {
    label: PropTypes.string.isRequired
}

export default CambistaTemplate